<template>
  <main class="c-main">
    <div class="row">
      <div class="col-md-12">
        <b-collapse id="findProductBlock">
          <b-card>
            <input type="text" class="form-control" placeholder="Код класса" v-model="titleOrCode"/>
            <div class="card-body" v-if="products.length > 0">
              <table class="table table-bordered table-striped" id="serverDataTable">
                <thead>
                <tr>
                  <th>ID</th>
                  <th>Класс ( Код - Наименование)</th>
                  <th>Действие</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(product, index) in products" :key="index" :class="{'bg-danger': product.state !== 'A'}">
                  <td>{{ product.id }}</td>
                  <td>{{ product.code }} {{ product.title }}</td>
                  <td>
                    <a v-if="product.state === 'A'" class="btn btn-warning cursor mr-4" @click="getProduct(product.id)">
                      Изменить
                    </a>
                    <a v-if="product.state === 'A'" href="javascript:void(0);" @click="deleteProduct(product.id)" class="btn btn-danger">Удалить</a>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </b-card>
        </b-collapse>

        <div class="modal-mask" v-show="showProductModal" transition="modal">
          <div class="modal-wrapper">
            <div class="modal-container">
              <div class="modal-header">
                <slot name="header">Категория</slot>
              </div>

              <div class="modal-body">
                <div class="form-group">
                  <label>Заголовок</label>
                  <input type="text" class="form-control" v-model="product.title"/>
                </div>
                <div class="form-group">
                  <label>Код</label>
                  <input type="text" class="form-control" v-model="product.code"/>
                </div>

              </div>

              <div class="modal-footer">
                <slot name="footer">
                  <button class="modal-button btn btn-danger" @click="closeCategoryModal()">Закрыть</button>
                  <button class="modal-button btn btn-success" @click="productUpdate()">Изменить</button>
                </slot>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import {GET, DELETE, POST} from "@/shared/api";

export default {
  data() {
    return {
      showProductModal: false,
      titleOrCode: null,
      product: {},
      products: [],
      searchValue: "",
      awaitingSearch: false,
      searchTimeout: 2000,
    };
  },
  methods: {
    openProductModal() {
      this.showProductModal = true;
    },
    closeCategoryModal() {
      this.showProductModal = false;
    },
    getProduct(id) {
      for (let i = 0; i < this.products.length; i++) {
        if (this.products[i].id === id) {
          this.product = this.products[i]
        }
      }
      this.openProductModal();
    },
    findProduct() {
      GET({search: this.searchValue,with:["category"]}, "/productSearch", this, false).then(response => {
        this.products = response;
      });
    },
    productUpdate() {
      POST(this.product, "/productUpdate", this).then(response => {
        this.closeCategoryModal();
        this.findProduct();
      });
    },
    deleteProduct(id) {
      DELETE(id, "/product", this).then(response => {
        this.findProduct();
      });
    }
  },
  watch: {
    titleOrCode: function (value) {
      this.searchValue = value;
      if (!this.awaitingSearch) {
        setTimeout(() => {
          if (value !== "") {
            this.findProduct(value);
          } else {
            this.products = [];
          }
          this.awaitingSearch = false;
        }, this.searchTimeout); // 1 sec delay
      }
      this.awaitingSearch = true;
    },
  },
};
</script>
